/* Pro-Dose Clinical — storefront engine
   Cart drawer (AJAX), variant picker, quantity steppers,
   attestation gate, scroll reveals, mobile menu. */

(function () {
  'use strict';

  var PD = window.ProDose || {};

  function formatMoney(cents) {
    var format = PD.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount\s*\}\}/, parts.join('.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts.join(','));
  }

  /* ---------- mobile menu ---------- */

  var menu = document.getElementById('MobileMenu');
  document.querySelectorAll('[data-menu-open]').forEach(function (btn) {
    btn.addEventListener('click', function () { menu && menu.classList.add('is-open'); });
  });
  document.querySelectorAll('[data-menu-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { menu && menu.classList.remove('is-open'); });
  });

  /* ---------- scroll reveal ---------- */

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- quantity steppers (event delegation) ---------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrap = btn.closest('.qty-input');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-change'), 10);
    var next = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 0) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- cart drawer ---------- */

  var drawer = document.getElementById('CartDrawer');
  var overlay = document.getElementById('DrawerOverlay');

  function openDrawer() { document.body.classList.add('drawer-open'); }
  function closeDrawer() { document.body.classList.remove('drawer-open'); }

  document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
  });
  document.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
    btn.addEventListener('click', closeDrawer);
  });
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* Shipping protection: the fee line must never count toward free-shipping /
     gift thresholds, never show a qty stepper, and the checkbox must mirror the
     cart (never pre-ticked on a cart that lacks the line). */
  function protectHandle() {
    var el = document.querySelector('[data-ship-protect]');
    return el ? el.getAttribute('data-protect-handle') : null;
  }
  function protectTotal(cart) {
    var handle = protectHandle();
    if (!handle) return 0;
    return cart.items.reduce(function (sum, item) {
      return item.handle === handle ? sum + item.final_line_price : sum;
    }, 0);
  }
  function syncProtectToggles(cart) {
    var handle = protectHandle();
    if (!handle) return;
    var inCart = cart.items.some(function (item) { return item.handle === handle; });
    document.querySelectorAll('[data-ship-protect-toggle]').forEach(function (box) {
      box.checked = inCart;
      box.disabled = false;
    });
  }

  function renderDrawer(cart) {
    if (!drawer) return;
    var body = drawer.querySelector('[data-drawer-body]');
    var subtotal = drawer.querySelector('[data-drawer-subtotal]');
    var counts = document.querySelectorAll('[data-cart-count]');

    counts.forEach(function (c) {
      c.textContent = cart.item_count;
      c.setAttribute('data-count', cart.item_count);
    });
    if (subtotal) subtotal.textContent = formatMoney(cart.items_subtotal_price);

    renderShipBar(drawer.querySelector('[data-ship-bar]'), cart.items_subtotal_price - protectTotal(cart));
    syncProtectToggles(cart);

    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty.</p></div>';
      return;
    }
    var handle = protectHandle();
    body.innerHTML = cart.items.map(function (item, i) {
      if (handle && item.handle === handle) {
        return '<div class="cart-line cart-line--service">' +
          '<div><span class="cart-line__title">' + item.product_title + '</span></div>' +
          '<div class="cart-line__price">' + formatMoney(item.final_line_price) + '</div>' +
        '</div>';
      }
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2') + '" alt="" loading="lazy">'
        : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<div class="cart-line__variant">' + item.variant_title + '</div>' : '';
      return '<div class="cart-line">' +
        '<div class="cart-line__media">' + img + '</div>' +
        '<div>' +
          '<a class="cart-line__title" href="' + item.url + '">' + item.product_title + '</a>' +
          variant +
          '<div class="qty-input" style="margin-top:8px">' +
            '<button type="button" data-qty-change="-1" aria-label="Decrease">&minus;</button>' +
            '<input type="number" min="0" value="' + item.quantity + '" data-line="' + (i + 1) + '" data-drawer-qty>' +
            '<button type="button" data-qty-change="1" aria-label="Increase">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="cart-line__price">' + formatMoney(item.final_line_price) + '</div>' +
      '</div>';
    }).join('');
  }

  /* protection toggle — works in drawer and on the cart page */
  document.addEventListener('change', function (e) {
    var box = e.target.closest('[data-ship-protect-toggle]');
    if (!box) return;
    var wrap = box.closest('[data-ship-protect]');
    var variantId = parseInt(wrap.getAttribute('data-protect-variant'), 10);
    var handle = wrap.getAttribute('data-protect-handle');
    box.disabled = true;
    var done = function () {
      if (document.body.classList.contains('template-cart')) { window.location.reload(); }
      else { fetchCart().then(renderDrawer); }
    };
    if (box.checked) {
      fetch(PD.cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(done).catch(function () { box.checked = false; box.disabled = false; });
    } else {
      fetchCart().then(function (cart) {
        var line = cart.items.find(function (item) { return item.handle === handle; });
        if (!line) { box.disabled = false; return; }
        return fetch(PD.cartChangeUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: 0 })
        }).then(done);
      }).catch(function () { box.disabled = false; });
    }
  });

  function renderShipBar(el, subtotal) {
    if (!el) return;
    var shipAt = PD.freeShippingThreshold || 0;
    var giftAt = PD.giftThreshold || 0;
    if (!shipAt) { el.hidden = true; return; }
    el.hidden = false;
    var label = el.querySelector('.ship-bar__label');
    var fill = el.querySelector('.ship-bar__fill');
    // Rungs are sorted rather than assumed. This used to hardcode gift-then-shipping, which
    // was right at gift $75 / shipping $150 and silently wrong the moment free shipping
    // dropped to $60 — it would have offered the gift rung to a cart that had already passed
    // the shipping one, and never announced free shipping at all.
    var rungs = [];
    if (shipAt) rungs.push({ at: shipAt, need: 'free shipping', got: 'free shipping' });
    if (giftAt) rungs.push({ at: giftAt, need: 'a free Reynard prep pad box', got: 'free Reynard box' });
    rungs.sort(function (a, b) { return a.at - b.at; });

    if (label) {
      var next = null;
      var cleared = [];
      rungs.forEach(function (r) { if (subtotal < r.at) { if (!next) next = r; } else { cleared.push(r.got); } });

      if (next) {
        var prefix = cleared.length ? cleared.join(' + ') + ' unlocked ✓ — add ' : 'Add ';
        // Sentence-case the prefix without capitalising a brand name mid-string.
        label.innerHTML = (cleared.length ? prefix.charAt(0).toUpperCase() + prefix.slice(1) : prefix)
          + '<strong>' + formatMoney(next.at - subtotal) + '</strong> more for ' + next.need;
      } else {
        label.innerHTML = '<strong>Unlocked: ' + cleared.join(' + ') + '.</strong>';
      }
    }

    // Scale the bar to the highest rung so the final one is actually reachable on it.
    var top = rungs.length ? rungs[rungs.length - 1].at : shipAt;
    var pct = Math.min(100, Math.round((subtotal / top) * 100));
    if (fill) fill.style.transform = 'scaleX(' + (pct / 100) + ')';
  }

  function fetchCart() {
    return fetch(PD.cartUrl + '.js').then(function (r) { return r.json(); });
  }

  fetchCart().then(renderDrawer);

  // one-tap upsell add (cart page + drawer)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-upsell-add]');
    if (!btn) return;
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch(PD.cartAddUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(btn.getAttribute('data-upsell-add'), 10), quantity: 1 })
    }).then(function () {
      if (document.body.classList.contains('template-cart')) { window.location.reload(); }
      else {
        fetchCart().then(renderDrawer);
        // The upsell block is server-rendered Liquid, so re-rendering the drawer body
        // won't drop the item that was just added — pull the card out by hand. Rail cards
        // go individually; the compact single-item row goes whole. Empty the rail once its
        // last card leaves, otherwise a bare "Complete the set" heading is left behind.
        var card = btn.closest('.cart-upsell-rail__card') || btn.closest('.cart-upsell');
        if (card) {
          var rail = card.closest('.cart-upsell-rail');
          card.remove();
          if (rail && !rail.querySelector('.cart-upsell-rail__card')) rail.remove();
        }
      }
    }).catch(function () { window.location.href = PD.cartUrl; });
  });

  /* ---------- "Complete your setup" multi-add (PDP) ---------- */

  var setup = document.querySelector('[data-setup]');
  if (setup) {
    var setupBtn = setup.querySelector('[data-setup-add]');
    var setupTotalEl = setup.querySelector('[data-setup-total]');
    var setupCountEl = setup.querySelector('[data-setup-count]');

    function setupChecked() {
      return Array.prototype.slice
        .call(setup.querySelectorAll('[data-setup-check]'))
        .filter(function (c) { return c.checked; });
    }

    function renderSetupTotal() {
      var checked = setupChecked();
      var total = checked.reduce(function (sum, c) {
        return sum + (parseInt(c.getAttribute('data-price'), 10) || 0);
      }, 0);
      if (setupTotalEl) setupTotalEl.textContent = formatMoney(total);
      if (setupCountEl) {
        setupCountEl.textContent = checked.length === 1 ? '1 item' : checked.length + ' items';
      }
      // Nothing ticked means nothing to add — an enabled button that silently does
      // nothing is worse than a disabled one.
      if (setupBtn) setupBtn.disabled = checked.length === 0;
      setup.querySelectorAll('[data-setup-item]').forEach(function (item) {
        var box = item.querySelector('[data-setup-check]');
        item.classList.toggle('is-off', !(box && box.checked));
      });
    }

    setup.addEventListener('change', function (e) {
      if (e.target.matches('[data-setup-check]')) renderSetupTotal();
    });
    renderSetupTotal();

    if (setupBtn) {
      setupBtn.addEventListener('click', function () {
        var items = setupChecked().map(function (c) {
          return { id: parseInt(c.value, 10), quantity: 1 };
        });
        if (!items.length) return;
        setupBtn.disabled = true;
        setupBtn.classList.add('is-busy');
        fetch(PD.cartAddUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          // /cart/add.js is all-or-nothing: one unavailable variant rejects the whole
          // batch, so don't report success off a non-2xx.
          if (!r.ok) throw new Error('add failed');
          return fetchCart();
        }).then(function (cart) {
          renderDrawer(cart);
          openDrawer();
          setupBtn.classList.remove('is-busy');
          // Untick what is now in the cart so a second press can't double-add.
          setupChecked().forEach(function (c) { c.checked = false; });
          renderSetupTotal();
        }).catch(function () { window.location.href = PD.cartUrl; });
      });
    }
  }

  drawer && drawer.addEventListener('change', function (e) {
    var input = e.target.closest('[data-drawer-qty]');
    if (!input) return;
    fetch(PD.cartChangeUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(input.getAttribute('data-line'), 10), quantity: parseInt(input.value, 10) || 0 })
    }).then(function (r) { return r.json(); }).then(renderDrawer);
  });

  /* ---------- AJAX add-to-cart ---------- */

  document.querySelectorAll('form[data-ajax-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      fetch(PD.cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: parseInt(form.querySelector('[name="id"]').value, 10),
          quantity: parseInt((form.querySelector('[name="quantity"]') || { value: 1 }).value, 10) || 1
        })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(fetchCart)
        .then(function (cart) { renderDrawer(cart); openDrawer(); })
        .catch(function () { window.location.href = PD.cartUrl; })
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = original; } });
    });
  });

  /* ---------- variant picker ---------- */

  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var dataEl = root.querySelector('[data-variant-json]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = root.querySelector('[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var skuEl = root.querySelector('[data-sku]');
    var submitBtn = root.querySelector('[data-submit]');

    function selectedOptions() {
      return Array.prototype.map.call(root.querySelectorAll('.option-pills'), function (group) {
        var sel = group.querySelector('.option-pill.is-selected');
        return sel ? sel.getAttribute('data-value') : null;
      });
    }

    function resolve() {
      var opts = selectedOptions();
      var match = variants.find(function (v) {
        return opts.every(function (o, i) { return o === null || v.options[i] === o; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = formatMoney(match.compare_at_price);
          compareEl.hidden = false;
        } else { compareEl.hidden = true; }
      }
      if (skuEl && match.sku) skuEl.textContent = match.sku;
      if (submitBtn) {
        submitBtn.disabled = !match.available;
        submitBtn.textContent = match.available ? 'Add to cart' : 'Sold out';
      }
      // back-in-stock capture: reveal when unavailable, hide when buyable
      var bis = document.getElementById('BackInStock');
      if (bis) {
        bis.hidden = match.available;
        var bisBody = document.getElementById('BISBody');
        if (bisBody) {
          var titleEl = document.querySelector('.product-info h1');
          var title = titleEl ? titleEl.textContent.trim() : '';
          var picked = opts.filter(Boolean).join(' / ');
          bisBody.value = 'Back-in-stock request: ' + title + (picked ? ' — ' + picked : '');
        }
      }
      root.querySelectorAll('.option-group__label strong').forEach(function (s, i) {
        if (opts[i]) s.textContent = opts[i];
      });
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('click', function (e) {
      var pill = e.target.closest('.option-pill');
      if (!pill) return;
      pill.closest('.option-pills').querySelectorAll('.option-pill').forEach(function (p) {
        p.classList.remove('is-selected');
      });
      pill.classList.add('is-selected');
      resolve();
    });

    resolve();
  });

  /* ---------- product gallery ---------- */

  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main] img');
    gallery.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-gallery-thumb]');
      if (!thumb || !main) return;
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      main.src = thumb.getAttribute('data-src');
      main.alt = thumb.getAttribute('data-alt') || '';
    });
  });

  /* ---------- attestation gate (cart page) ---------- */

  var attestation = document.getElementById('AttestationCheck');
  var checkoutBtn = document.getElementById('CheckoutButton');
  if (attestation && checkoutBtn) {
    var sync = function () { checkoutBtn.disabled = !attestation.checked; };
    attestation.addEventListener('change', sync);
    sync();
  }

  /* ---------- cart page quantity updates ---------- */

  document.querySelectorAll('[data-cart-page-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      fetch(PD.cartChangeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(input.getAttribute('data-line'), 10), quantity: parseInt(input.value, 10) || 0 })
      }).then(function () { window.location.reload(); });
    });
  });
})();

/* ---------- syringe unit calculator ----------
   Pure arithmetic. Never introduce compound presets or suggested doses here —
   see the compliance note in sections/syringe-calculator.liquid. */

(function () {
  var root = document.querySelector('[data-calc]');
  if (!root) return;

  var q = function (sel) { return root.querySelector(sel); };
  var powder = q('[data-calc-powder]'), powderUnit = q('[data-calc-powder-unit]');
  var diluent = q('[data-calc-diluent]');
  var dose = q('[data-calc-dose]'), doseUnit = q('[data-calc-dose-unit]');
  var syringe = q('[data-calc-syringe]');
  var empty = q('[data-calc-empty]'), result = q('[data-calc-result]');
  var elConc = q('[data-calc-conc]'), elUnits = q('[data-calc-units]'), elMl = q('[data-calc-ml]');
  var fill = q('[data-calc-fill]'), ticks = q('[data-calc-ticks]'), scale = q('[data-calc-scale]');
  var note = q('[data-calc-note]'), cta = q('[data-calc-cta]'), ctaLink = q('[data-calc-cta-link]');

  var BAR_X = 18, BAR_W = 330;

  function num(el) { var v = parseFloat(el.value); return isFinite(v) && v > 0 ? v : 0; }

  function drawTicks(capacityMl) {
    // U-100: 100 units per mL. Major tick every 10 units of a 1 mL barrel, scaled to capacity.
    var totalUnits = capacityMl * 100;
    var step = totalUnits <= 30 ? 5 : 10;
    var marks = '', labels = '';
    for (var u = 0; u <= totalUnits; u += step) {
      var pct = u / totalUnits;
      var x = BAR_X + pct * BAR_W;
      var major = (u % (step * 2) === 0);
      marks += '<line x1="' + x.toFixed(1) + '" y1="22" x2="' + x.toFixed(1) +
               '" y2="' + (major ? 34 : 29) + '" />';
      if (major) {
        labels += '<span style="left:' + (pct * 100).toFixed(2) + '%">' + u + '</span>';
      }
    }
    ticks.innerHTML = marks;
    scale.innerHTML = labels;
  }

  function render() {
    var mg = num(powder) * parseFloat(powderUnit.value);
    var ml = num(diluent);
    var doseMg = num(dose) * parseFloat(doseUnit.value);
    var capacity = parseFloat(syringe.value);

    if (!mg || !ml || !doseMg) {
      empty.hidden = false; result.hidden = true;
      return;
    }
    empty.hidden = true; result.hidden = false;

    var concentration = mg / ml;              // mg per mL
    var drawMl = doseMg / concentration;      // mL to draw
    var units = drawMl * 100;                 // U-100 units

    elConc.textContent = (concentration >= 1
      ? concentration.toFixed(2).replace(/\.?0+$/, '') + ' mg/mL'
      : (concentration * 1000).toFixed(1).replace(/\.?0+$/, '') + ' mcg/mL');
    elUnits.textContent = units.toFixed(units < 10 ? 2 : 1).replace(/\.?0+$/, '');
    elMl.textContent = drawMl.toFixed(3).replace(/0+$/, '').replace(/\.$/, '');

    drawTicks(capacity);
    var pct = Math.min(1, drawMl / capacity);
    fill.setAttribute('width', (pct * BAR_W).toFixed(1));

    // Guidance is about EQUIPMENT FIT ONLY — never about the dose itself.
    if (drawMl > capacity) {
      var needed = capacity === 1 ? null : 1;
      note.className = 'calc__note calc__note--warn';
      note.textContent = 'That volume (' + drawMl.toFixed(2) + ' mL) is larger than this syringe holds (' +
        capacity + ' mL). You would need a larger syringe, or to split it across more than one.';
      cta.hidden = false;
      ctaLink.textContent = 'See larger syringes';
      ctaLink.href = '/collections/syringes';
    } else if (units < 5) {
      note.className = 'calc__note';
      note.textContent = 'That lands under 5 units — a very small mark to read on a 1 mL barrel. ' +
        'A 0.3 mL syringe has the same graduations spread over a third of the length, which is easier to read accurately.';
      cta.hidden = false;
      ctaLink.textContent = 'See 0.3 mL insulin syringes';
      ctaLink.href = '/collections/syringes';
    } else {
      note.className = 'calc__note';
      note.textContent = 'Draw to the ' + elUnits.textContent + ' unit mark on a U-100 ' + capacity + ' mL syringe.';
      cta.hidden = true;
    }
  }

  [powder, powderUnit, diluent, dose, doseUnit, syringe].forEach(function (el) {
    el.addEventListener('input', render);
    el.addEventListener('change', render);
  });
  render();
})();
